import React from 'react';

const CustomBadge = ({ text, onClick }) => {
  return (
    <div className="flex items-center gap-2 border border-solid border-inactive-text rounded-full py-1 px-2">
      <span className="text-primary-text text-sm leading-5">{text}</span>
      <button
        className="bg-transparent border-none text-border-gray-400 cursor-pointer text-lg font-bold p-0 hover:text-yellow-500"
        onClick={onClick}>
        ×
      </button>
    </div>
  );
};

export default CustomBadge;
